import { media, styled } from '@styles';
import { Container } from '@components/templates/Container';
import { prismicRichText } from '@styles/utils';

export const Wrapper = styled(Container)`
  display: flex;
  flex-direction: row;
  ${media.smallScreen`
    display: block;
  `}
  ${prismicRichText}
`;

export const Paragraph = styled.div`
  width: calc(66% - 20px);
  margin-right: 20px;

  &.full-width {
    width: 100%;
  }

  &.empty-width {
    width: 0%;
  }

  &.reversed {
    margin-right: 0;
    margin-left: 20px;
  }

  ${media.smallScreen`
    width: 100%;
    margin: 0;
    margin-bottom: 40px;

    &.reversed {
      margin: 0;
      margin-bottom: 0;
    }
  `}
`;

export const Photo = styled.div`
  width: calc(33% - 20px);
  margin-left: 20px;

  & > div {
    display: flex;
    justify-content: center;
  }

  &.full-width {
    width: 100%;
  }

  &.empty-width {
    width: 0%;
  }

  &.reversed {
    margin-left: 0;
    margin-right: 20px;
  }

  ${media.smallScreen`
    width: 100%;
    margin: 0;
    margin-bottom: 0;

    &.reversed {
      margin: 0;
      margin-bottom: 40px;
    }
  `}
`;
